
export const placeHolder = (theme) => ({
  color: "#FFFFFF",
  fontStyle: "italic",
  opacity: 0.65,
  fontSize: "14px",
  fontWeight: 300,
  fontStretch: "normal",
  [theme.breakpoints.down('sm')]: {
    fontSize: "10px !important",
  },
});

export const alarmSearch = (theme) => ({
  backgroundColor: "#252d39 !important",
  fontSize: "16px",
  fontWeight: "500",
  width: "100%",
  borderRadius: "2px",
  "& .MuiInputBase-input": {
    color: "#FFFFFF",
    marginLeft: "10px",
    fontSize: "16px",
    [theme.breakpoints.down('sm')]: {
      fontSize: "10px !important",
    },
  },
  "& .MuiInputBase-input::placeholder": {
    ...placeHolder(theme),
  },
  "& .MuiInputBase-input::-ms-input-placeholder": {
    ...placeHolder(theme),
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: "10px !important",
    borderRadius: "2px",
  },
    })